<template>
  <div class="blog-item-short desk-c-pointer" @click="goToPage">
    <div v-if="article.thumbnailUrl" class="item-thumb-wr">
      <img :src="article.thumbnailUrl" :alt="article.title"/>
    </div>
    <div class="item-text-wr">
      <div class="item-title">{{ article.title }}</div>
      <div class="item-description">{{ article.previewDescription }}</div>
      <div class="item-date">{{ formatDate }}</div>
   </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "BlogArticleShortView",
  props: {
    article: {
      type: Object,
    },
  },
  data:()=>{
    return {}
  },
  computed: {
    formatDate() {
      return moment(this.article?.articleDate).format('DD/MM/YYYY')
    }
  },
  methods:{
    goToPage(){
      this.$router.push({name: 'blog-page', params:{page: this.article?.urlPageName}})
    }
  }
}
</script>

<style scoped lang="scss">
  .blog-item-short {
    line-height: 1.1;
    display: flex;
    gap: 1rem;

    .item-thumb-wr {
      width: 15rem;
      min-width: 15rem;
      max-width: 15rem;

      img { 
        width: 100% 
      }
    }

    .item-text-wr {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }

    .item-title {
      font-size: 1.5rem;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }
    .item-description {
      font-size:  1rem;
      color: var(--geoff-txt-secondary);
      margin-bottom: 0.5rem;
      flex-grow: 1;
    }
    .item-date {
      font-size:  0.875rem;
      color: var(--geoff-txt-note);
      text-align: end;
    }
    @media only screen and (max-width: 620px){
      flex-direction: column;
      .item-thumb-wr {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
      }

    }
  }

  
</style>